import type { WorkflowReviewStatusData } from '@app/shared/types/sf-data'

export type WorkflowOverviewGroup = {
  id: number
  type: 'group'
  name: string
  children: Array<WorkflowOverviewItem | WorkflowOverviewGroup>
}

export type WorkflowOverviewItemType = 'account_entry' | 'reconciliation_text'

export type WorkflowOverviewItem = {
  id: number
  name: string
  accountEntryId?: number | null
  contextHrefParam?: string | null
  originalNumber?: string | null
  reviewIndex: number
  type?: WorkflowOverviewItemType
  workflowReviewStatusData: WorkflowReviewStatusData | null
  children: undefined
  path: string
  proposalPath: string
}

export type PreparedWorkflowOverviewAccountEntry = {
  id: number
  preparedName: Fuzzysort.Prepared
  preparedNumber: Fuzzysort.Prepared
  preparedOriginalNumber: Fuzzysort.Prepared
}

export type PreparedWorkflowOverviewReconciliationText = {
  id: number
  preparedName: Fuzzysort.Prepared
}

export type PulseReconciliationStatusData = {
  id: number
  name: string
  type: string
  reconciled: boolean
}
export type PulseWorkflowProgress = {
  error?: boolean
  progress: number
  statuses: Array<PulseReconciliationStatusData>
}
export enum UserTypes {
  INTERNAL_USER = 'internal',
  PULSE_USER = 'pulse',
}

export type UserType = UserTypes.INTERNAL_USER | UserTypes.PULSE_USER
